import React, {FunctionComponent} from 'react'
import {Navbar} from "@App/Components/Navbar";
import {Footer} from "@App/Layouts/Footer";
import {Outlet} from "react-router-dom";
import {State} from "@App/state";
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";

export const Layout: FunctionComponent = () => {
    const organization = useSelector((state: State) => state.orders.organization)
    const {t} = useTranslation()
    return (
        <div className="text-neutral-400">
            <Navbar>
                <div className={'flex items-center gap-5'}>
                    <img src="/images/brand/fleethub.png" className={"w-[85px] md:w-[107px] h-[40px] md:h-[50px]"}
                         alt="Fleethub"/>
                    <a href={organization.settings.hero.link} className="hidden md:flex gap-1 items-center text-xs text-neutral-700 font-normal no-underline border border-neutral-300 rounded p-2">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4"
                             viewBox="0 0 20 20"
                             fill="#2f3237">
                            <path fillRule="evenodd"
                                  d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                                  clipRule="evenodd"/>
                        </svg>
                        {t('layout.backText')}
                    </a>
                </div>
                <a href={'https://www.repareo.de'} className={'flex'} title={"repareo Werkstattvergleich"}>
                    <img
                        src="/images/brand/logo-light.svg"
                        className="w-24 h-auto"
                        alt=""
                    />
                </a>
            </Navbar>
            <Outlet/>
            <Footer/>
        </div>
    )
}
